









import { defineComponent, PropType } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import { TextAlign } from "../../../../../config";

export default defineComponent({
  name: "FontAlign",
  components: { BaseIconButton },
  props: {
    currentTextAlign: { type: String as PropType<TextAlign>, required: true },
  },
  setup() {
    const settingsButton: Record<TextAlign, { icon: string; toggleAlign: TextAlign }> = {
      [TextAlign.LEFT]: { icon: "sci-format-align-left", toggleAlign: TextAlign.RIGHT },
      [TextAlign.CENTER]: { icon: "sci-format-align-center", toggleAlign: TextAlign.LEFT },
      [TextAlign.RIGHT]: { icon: "sci-format-align-right", toggleAlign: TextAlign.CENTER },
    };

    return {
      settingsButton,
      TextAlign,
    };
  },
});
